<span class="pill-inner" (mousedown)="onPillMousedown($event)" (click)="onClick($event)">
  @if (editing()) {
    <input
      #editEl
      class="pill-edit"
      type="text"
      size="1"
      spellcheck="false"
      autocomplete="off"
      (input)="onPillEditInput($event)"
      (blur)="onEditBlur()"
      (keydown)="onEditKeydown($event)"
    />
  } @else {
    <span class="pill-name">{{ name }}</span>
    @if (!readonly) {
      <button
        class="pill-remove"
        type="button"
        aria-label="Remove variable"
        (mousedown)="$event.preventDefault()"
        (click)="onRemoveClick($event)"
      >×</button>
    }
  }
</span>
